module.exports = __webpack_public_path__ + "static/media/compalHero.7c808578.jpg";